import React, { useEffect, useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'

import { useTranslation } from 'react-i18next'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { AccountWrapper, Field, SecureField, Awaiter } from './components'
import * as requests from '#src/requests'
import { useRecoilState } from 'recoil'
import { accountEmailState } from '#state'

const emailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

export default function ResetPassword (props) {
  const { root, to } = props
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [email, setEmail] = useRecoilState(accountEmailState)

  const [loginError, setLoginError] = useState('')
  const [showErrors, setShowErrors] = useState(false)
  const [isAwaiting, setIsAwaiting] = useState(false)

  useEffect(() => {
    if (email === '') {
      const errMessage = t('account.errors.emptyEmail')
      setLoginError(errMessage)
    } else if (!email.match(emailformat)) {
      const errMessage = t('account.errors.incorrectEmail')
      setLoginError(errMessage)
    } else {
      setLoginError('')
    }
  }, [email])

  const check = async event => {
    // app root reload \ rerender fix
    event.preventDefault()
    if (loginError) {
      console.log('login or pass incorrect')
      setShowErrors(true)
    } else {
      setIsAwaiting(true)
      const result = await requests.resetcode(email)
      setIsAwaiting(false)
      if (!result.success) {
        console.log('Reset error', result)
        if (result.error) {
          setShowErrors(true)
          const errMessage = t(`account.errors.${result.error}`)
          console.log('errMessage', errMessage)
          setLoginError(errMessage)
        } else {
          setLoginError('')
        }
      } else {
        setShowErrors(false)
        console.log('Reset success', result)
        // setToken(result.token)
        // trackEvent('Login')
        navigate('/account/updatepass', { replace: true })
      }
    }
  }

  return (
    <>
      <AccountWrapper root={root} to={to}>
        <Grid
          component='form'
          container
          direction='column'
          alignItems='center'
          justifyContent='space-evenly'
          sx={{
            px: 5,
            py: 5,
            borderRadius: 2,
            // border: '1px solid',
            // borderColor: 'action.selected'
          }}
          onSubmit={check}
        >
          <Grid
            item
            container
            direction='column'
            alignItems='center'
            justifyContent='space-between'
            sx={{
              minHeight: '15vh'
            }}
          >
            <Typography textAlign='center' variant='h4'>{t('account.resetPass.title')}</Typography>

            <Grid item container alignItems='center' justifyContent='center'>
              <Typography>{t('account.resetPass.createPre')}</Typography>
              <Button
                sx={{ textTransform: 'none', cursor: 'pointer' }}
                onClick={() => {
                  navigate('/account/register', { replace: true })
                }}
              >
                <Typography>{t('account.resetPass.createLink')}</Typography>
              </Button>
            </Grid>
          </Grid>

          <Grid
            item
            container
            direction='column'
            alignItems='stretch'
            justifyContent='space-evenly'
            sx={{
              minHeight: '13vh'
            }}
          >
            <Field
              value={email}
              setValue={setEmail}
              label={t('account.resetPass.emailLabel')}
              placeholder={t('account.resetPass.emailPlaceholder')}
              errorMessage={loginError}
              showErrors={showErrors}
            />
          </Grid>
          <Grid
            item
            container
            direction='column'
            alignItems='center'
            justifyContent='space-between'
            sx={{
              minHeight: '25vh'
            }}
          >
            <Button
              fullWidth
              variant='contained'
              size='large'
              type="submit"
            >
              <Typography>{t('account.resetPass.mainBtn')}</Typography>
            </Button>
            <Button
              sx={{ textTransform: 'none', cursor: 'pointer' }}
              onClick={() => {
                navigate('/account/updatepass', { replace: true })
              }}
            >
              <Typography>{t('account.resetPass.resetLink')}</Typography>
            </Button>
            <Button
              fullWidth
              variant='outlined'
              size='large'
              onClick={() => {
                navigate('/account/otclogin', { replace: true })
              }}
            >
              <Typography>{t('account.resetPass.otcBtn')}</Typography>
            </Button>
          </Grid>
        </Grid>
      </AccountWrapper>
      <Awaiter isAwaiting={isAwaiting} />
    </>
  )
}
